import { render, staticRenderFns } from "./SimpleDiversity.vue?vue&type=template&id=1548fef7&scoped=true"
import script from "./SimpleDiversity.vue?vue&type=script&lang=js"
export * from "./SimpleDiversity.vue?vue&type=script&lang=js"
import style0 from "./SimpleDiversity.vue?vue&type=style&index=0&id=1548fef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548fef7",
  null
  
)

export default component.exports